import Axios from "axios";
import config from "configs/config";
import getText from "Translator";
const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};

export const insertPersonalPageAnswer = async (newData, controller) => {
  try {
    let url = config.apiserverapp + "/page/insertPersonalPageAnswer/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
